import { render, staticRenderFns } from "./AdminResendWelcomeEmail.vue?vue&type=template&id=089a1a81&"
import script from "./AdminResendWelcomeEmail.vue?vue&type=script&lang=js&"
export * from "./AdminResendWelcomeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports